import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DISPLAY, MONO, Container, SecHead, ArrowRight } from './home/ui';

// Mosaico "Compra por tu peludo" (diseño v1-marketplace): la primera
// categoría ocupa dos filas; el resto, una celda cada una.
const GRADIENTS = [
    'linear-gradient(135deg, #fef3c7, #fbbf24)',
    'linear-gradient(135deg, #e0e7ff, #818cf8)',
    'linear-gradient(135deg, #dcfce7, #22c55e)',
    'linear-gradient(135deg, #cffafe, #06b6d4)',
    'linear-gradient(135deg, #fce7f3, #ec4899)',
];
const EMOJIS = ['🐶', '🐱', '🐦', '🐠', '🐹'];

const Categorys = () => {
    const { categorys, products } = useSelector(state => state.home);
    const tiles = categorys.filter(c => c && c.name).slice(0, 5);
    if (!tiles.length) return null;

    const countOf = (name) => products.filter(p => p.category === name).length;

    return (
        <section className='py-12'>
            <Container>
                <SecHead
                    title={<>Compra por <em>tu peludo</em></>}
                    sub='Todo lo que tu compañero necesita, organizado por especie.'
                    to='/shops'
                    cta='Ver todas las categorías'
                />

                <div className='grid gap-4 grid-cols-[1.4fr_1fr_1fr] grid-rows-[repeat(2,260px)] md-lg:grid-cols-2 md-lg:grid-rows-none md-lg:auto-rows-[220px] sm:grid-cols-1 sm:auto-rows-[180px]'>
                    {tiles.map((c, i) => {
                        const big = i === 0;
                        const n = countOf(c.name);
                        return (
                            <Link
                                key={c._id || i}
                                to={`/products?category=${c.name}`}
                                className={`group relative rounded-[22px] overflow-hidden flex flex-col justify-end p-6 text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_50px_-20px_rgba(15,23,42,.25)] ${big ? 'row-span-2 md-lg:row-span-1' : ''}`}
                                style={{ isolation: 'isolate' }}
                            >
                                <div className='absolute inset-0 z-0' style={{ background: GRADIENTS[i % GRADIENTS.length] }} />
                                {c.image && <img src={c.image} alt='' className='absolute inset-0 z-0 w-full h-full object-cover opacity-50' />}
                                <div className='absolute inset-0 z-[1] pointer-events-none' style={{ background: 'linear-gradient(180deg, transparent 30%, rgba(0,0,0,.55) 100%)' }} />

                                {!c.image && (
                                    <div className={`absolute top-[18px] right-[18px] z-[2] opacity-50 leading-none ${big ? 'text-[80px] md-lg:text-[48px]' : 'text-[48px]'}`}
                                        style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,.15))' }} aria-hidden='true'>
                                        {EMOJIS[i % EMOJIS.length]}
                                    </div>
                                )}

                                <div className='relative z-[2] flex flex-col gap-[6px]'>
                                    {n > 0 && (
                                        <span className='text-[11.5px] font-semibold opacity-85 tracking-[.04em] uppercase' style={MONO}>
                                            {n} {n === 1 ? 'producto' : 'productos'}
                                        </span>
                                    )}
                                    <h3 className={`font-bold m-0 leading-none tracking-[-.015em] ${big ? 'text-[42px] md-lg:text-[30px]' : 'text-[30px]'}`} style={DISPLAY}>
                                        {c.name}
                                    </h3>
                                    <span className='mt-[10px] self-start inline-flex items-center gap-2 text-[13px] font-bold bg-white/20 border border-white/30 rounded-full px-[14px] py-2 transition-all group-hover:bg-white group-hover:text-[#1e3a8a] group-hover:border-white' style={{ backdropFilter: 'blur(6px)' }}>
                                        Explorar <ArrowRight className='w-[13px] h-[13px]' strokeWidth={2.6} />
                                    </span>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </Container>
        </section>
    );
};

export default Categorys;
